package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.update_restaurant_project


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject

@Serializable
data class CashAssist(
    @SerialName("__typename")
    val typename: String?,
    @SerialName("updateProject")
    val updateProject: RestaurantProject?
)